export const iconSizes = {
  notificationDot: 11,
  sm: 16,
  md: 20,
  lg: 24,
  logo: 32,
  xl: 36,
  xxl: 40,
} as const;
